import Helper from './Helper';

class InteractiveSVGPopup {
  constructor(svgSelector) {

    this.svg = document.querySelector(svgSelector);
    if(!this.svg) return;
    this.interactiveContainer = this.svg.closest('.ns-interactive-svg-container');
    this.targetItems = [...this.interactiveContainer.querySelectorAll('.ns-interactive-svg-item')];

    this.targetItems = this.targetItems.map(item => {
      let id = item.querySelector('.ns-interactive-svg-item__id').innerText;
      item.id = 'target-' + id.trim();

      return {
        match: id,
        node: item
      };
    });

    console.log(this.targetItems)

    this.bindEvents();
  }

  bindEvents() {
    this.triggers = this.svg.querySelectorAll('[id^="trigger-"]');

    this.triggers.forEach(trigger => {
      let triggerID = trigger.id.split('-')[1];
      let item = this.targetItems.filter(item => item.match == triggerID);

      if (item.length > 0) {
        item = item[0];
      }

      trigger.addEventListener('click', (e) => {
        if (Helper.isDesktop()) {
          if (item) {
            if (trigger.classList.contains('active')) {
              this.deactivateAll();
            } else {
              this.deactivateAll();
              trigger.classList.add('active');
              item.node?.classList.add('active');
            }
          }
        }
      });

      if (Helper.isDesktop() && trigger.classList.contains('default')) {
        // trigger.click(); //click dosent work and i cant be bothered by it right now
        trigger.classList.add('active');
        this.interactiveContainer.querySelector('#target-'+triggerID).classList.add('active');
      }
    });
  }

  deactivateAll() {
    this.triggers.forEach(item => {
      item.classList.remove('active');
    })

    this.targetItems.forEach(item => {
      item.node.classList.remove('active');
    })
  }

}
export default InteractiveSVGPopup;